import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { STONE_BANNER } from '../../../constants/stone';
import { ExpStoneBanner } from '../../../experiments/declarations';
import { selectMapBounds } from '../../../selectors/mapBounds';
import { selectParentRegionId } from '../../../selectors/parentRegionId';
import { selectJsonQuery } from '../../../selectors/results';
import { TAdfoxMapBannerConfig, TAdfoxMapBannerConfigItem } from '../../../types/adfoxMapBannerConfig';
import { IApplicationState } from '../../../types/redux';
import { getAdfoxBannerConfig } from '../../../utils/bannerPackages';
import { useApplicationContext } from '../../ApplicationContext';

export function useSelectedAdfoxBannerConfig(): TAdfoxMapBannerConfigItem | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const { zoom } = useSelector(selectMapBounds);
  const adfoxMapBannerConfig = useSelector((state: IApplicationState) => state.config.adfoxMapBannerConfig);
  const parentRegionId = useSelector(selectParentRegionId);
  const { config } = useApplicationContext();

  const isStoneExperimentActive = ExpStoneBanner.use() === 'B';

  const adfoxEnabled = config.get<boolean>('mapSearchFrontend.AdfoxMapBanner.Enabled') || false;

  const filteredConfig = useMemo<TAdfoxMapBannerConfig>(() => {
    return adfoxMapBannerConfig.filter(item => {
      if (item.developerId === STONE_BANNER.developerId) {
        return isStoneExperimentActive;
      }

      return true;
    });
  }, [adfoxMapBannerConfig, isStoneExperimentActive]);

  return getAdfoxBannerConfig({
    zoom,
    jsonQuery,
    deviceType,
    adfoxEnabled,
    adfoxMapBannerConfig: filteredConfig,
    parentRegionId,
  });
}
